import initStoreSe from './stores/se'
import initStoreGeo from './stores/geo'

import eventNames from './events/names'
import initEvents from './events'

import compareDeepValue from '../../../fns/compare/deep-value'

const initStore = ({ instance, events }) => {
    const seStore = initStoreSe(instance)
    const geoStore = initStoreGeo(instance)

    let capacityMapById = null

    const onSelectedCriterias = (criterias, fn, fired) => {
        let lastSelectedCriterias = getSelectedCriterias(criterias)
        lastSelectedCriterias.sort() // list of ids
        let n = 0

        const handler = () => {
            const selectedCriterias = getSelectedCriterias(criterias)
            selectedCriterias.sort()
            const changed = !compareDeepValue(lastSelectedCriterias, selectedCriterias)
            if ((fired && n === 0) || changed) {
                lastSelectedCriterias = selectedCriterias
                fn()
            }
            n++
        }
        events.on(eventNames.FILTERS, handler, fired)
        return () => events.off(eventNames.FILTERS, handler)
    }
    const onAvailableCriterias = (criterias, fn, fired) => {
        let lastAvailableCriterias = getAvailableCriterias(criterias)
        lastAvailableCriterias.sort()
        let n = 0

        const handler = () => {
            const availableCriterias = getAvailableCriterias(criterias)
            availableCriterias.sort((a, b) => a.id > b.id)
            const changed = !compareDeepValue(lastAvailableCriterias, availableCriterias)
            if ((fired && n === 0) || changed) {
                lastAvailableCriterias = availableCriterias
                fn()
            }
            n++
        }
        events.on(eventNames.COUNTERS, handler, fired)
        return () => events.off(eventNames.COUNTERS, handler)
    }
    const onFieldValue = (field, fn, fired) => {
        let lastValue = getFieldValue(field)
        let n = 0

        const handler = () => {
            const value = getFieldValue(field)
            if ((fired && n === 0) || value !== lastValue) {
                lastValue = value
                fn()
            }
            n++
        }
        events.on(eventNames.FILTERS, handler, fired)
        return () => events.off(eventNames.FILTERS, handler)
    }
    const onCounters = (counterFields, fn, fired) => {
        let lastValues = counterFields.map((field) => {
            return getCounter(field)
        })
        let n = 0

        const handler = () => {
            const values = counterFields.map((field) => {
                return getCounter(field)
            })
            if ((fired && n === 0) || !compareDeepValue(lastValues, values)) {
                lastValues = values
                fn()
            }
            n++
        }
        events.on(eventNames.COUNTERS, handler, fired)
        return () => events.off(eventNames.COUNTERS, handler)
    }
    const onSelectedFieldValues = (field, fn, fired) => {
        let lastSelectedValues = getSelectedFieldValues(field)
        lastSelectedValues.sort() // list of ids
        let n = 0

        const handler = () => {
            const selectedValues = getSelectedFieldValues(field)
            selectedValues.sort()
            const changed = !compareDeepValue(lastSelectedValues, selectedValues)
            if ((fired && n === 0) || changed) {
                lastSelectedValues = selectedValues
                fn()
            }
            n++
        }
        events.on(eventNames.FILTERS, handler, fired)
        return () => events.off(eventNames.FILTERS, handler)
    }
    const onAvailableFieldValues = (field, fn, fired) => {
        let lastAvailableValues = getAvailableFieldValues(field)
        lastAvailableValues.sort() // list of objects {id, count}
        let n = 0

        const handler = () => {
            const availableValues = getAvailableFieldValues(field)
            availableValues.sort()
            const changed = !compareDeepValue(lastAvailableValues, availableValues)
            if ((fired && n === 0) || changed) {
                lastAvailableValues = availableValues
                fn()
            }
            n++
        }
        events.on(eventNames.COUNTERS, handler, fired)
        return () => events.off(eventNames.COUNTERS, handler)
    }

    const addCriterias = (criterias) => {
        // FILTERS event
        criterias.forEach((criteriaId) => {
            if (!seStore.request.criteria.includes(criteriaId)) {
                seStore.request.criteria.push(criteriaId)
            }
        })
        events.fire(eventNames.FILTERS)
    }
    const removeCriterias = (criterias) => {
        // FILTERS event
        criterias.forEach((criteriaId) => {
            seStore.request.criteria = seStore.request.criteria.filter((_criteriaId) => _criteriaId !== criteriaId)
        })
        events.fire(eventNames.FILTERS)
    }
    const setFieldValue = (field, value) => {
        // FILTERS event
        if (value === undefined) {
            delete seStore.request[field]
        } else {
            seStore.request[field] = value
        }
        events.fire(eventNames.FILTERS)
    }
    const addFieldValue = (field, value) => {
        // FILTERS event
        seStore.request[field] = seStore.request[field] || []
        if (!seStore.request[field].includes(value)) {
            seStore.request[field].push(value)
        }
        events.fire(eventNames.FILTERS)
    }
    const removeFieldValue = (field, value) => {
        // FILTERS event
        if (seStore.request[field]) {
            seStore.request[field] = seStore.request[field].filter((_value) => _value !== value)
            if (seStore.request[field].length === 0) {
                delete seStore.request[field]
            }
        }
        events.fire(eventNames.FILTERS)
    }
    // criterias and field values
    const getAvailableCriterias = (criterias) => {
        // get available criterias from the list of criterias
        if (!seStore.counters.criteria) {
            return []
        }
        if (criterias) {
            return criterias.filter((criteriaId) => {
                return seStore.counters.criteria.find(({ id }) => id === criteriaId)
            })
        } else {
            return seStore.counters.criteria.map(({ id }) => id)
        }
    }
    const getSelectedCriterias = (criterias) => {
        // get selected criterias from the list of criterias
        if (criterias) {
            return criterias.filter((criteriaId) => {
                return seStore.request.criteria.includes(criteriaId)
            })
        } else {
            return [...seStore.request.criteria]
        }
    }
    // for array fields
    const getAvailableFieldValues = (field, values) => {
        // get available field values for the field
        if (!seStore.counters[field]) {
            return []
        }
        if (values) {
            return values.filter((value) => {
                return seStore.counters[field].find(({ id }) => id === value)
            })
        } else {
            return [...seStore.counters[field]].map(({ id }) => id)
        }
    }
    const getAvailableCapacityValuesSorted = () => {
        if (!capacityMapById) {
            capacityMapById = {}
            instance.options.fields.capacity.forEach((item) => {
                capacityMapById[item.id] = item
            })
        }
        const capacity = getAvailableFieldValues('capacity')
        capacity.sort((a, b) => {
            var v1 = capacityMapById[a].value
            var v2 = capacityMapById[b].value
            return v1 - v2
        })
        return capacity
    }
    const getCounter = (field) => {
        return seStore.counters[field]
    }
    const getValueCounter = (field, id) => {
        const value = seStore.counters[field].find((value) => value.id === id)
        return value ? value.count : 0
    }
    const getCriteriaCounter = (id) => {
        const value = seStore.counters.criteria.find((criteria) => criteria.id === id)
        return value ? value.count : 0
    }
    // for array fields
    const getSelectedFieldValues = (field, values) => {
        // get selected field values for the field
        if (!seStore.request[field]) {
            return []
        }
        if (values) {
            return values.filter((value) => {
                return seStore.request[field].includes(value)
            })
        } else {
            return [...seStore.request[field]]
        }
    }
    const getFieldValue = (field) => {
        // get field value for the field
        return seStore.request[field]
    }
    const clearRequest = (options = {}) => {
        events.batch(() => {
            clearFilters(options)

            // RESULTS_PER_PAGE event
            seStore.resultsPerPage = '10'
            events.fire(eventNames.RESULTS_PER_PAGE)

            // PAGE event
            seStore.page = '0'
            events.fire(eventNames.PAGE)

            // SORT event
            seStore.sort = {
                type: null,
                direction: null
            }
            events.fire(eventNames.SORT)
        })
    }
    const clearFilters = (options = {}) => {
        const { keepFields = [] } = options

        const keepFieldsData = {}
        keepFields.forEach((field) => {
            keepFieldsData[field] = seStore.request[field]
        })

        // FILTERS event
        seStore.request = {
            criteria: [],
            season: getSeason(),
            ...keepFieldsData
        }
        events.fire(eventNames.FILTERS)
    }
    const setSort = ({ type, direction }) => {
        // SORT event
        seStore.sort = {
            type,
            direction
        }
        events.fire(eventNames.SORT)
    }
    const getSort = () => {
        return seStore.sort
    }
    const setResultsPerPage = (num) => {
        // RESULTS_PER_PAGE event
        seStore.resultsPerPage = num + ''
        events.fire(eventNames.RESULTS_PER_PAGE, seStore.resultsPerPage)
    }
    const getResultsPerPage = () => {
        return seStore.resultsPerPage
    }
    const setPage = (page) => {
        // PAGE event
        seStore.page = page
        events.fire(eventNames.PAGE)
    }
    const getPage = () => {
        return seStore.page
    }

    const setCriteriaCounters = (criterias) => {
        instance.options.criteriaCounters = [...criterias]
    }
    const setFieldCounters = (fields) => {
        instance.options.fieldCounters = [...fields]
    }

    const setExcluded = ({ criterias = [], fields = [] }) => {
        seStore.exclude.criterias = criterias
        seStore.exclude.fields = fields
    }
    const getExcluded = () => {
        return seStore.exclude
    }

    const expectedCounters = {}
    const setExpectedCounter = (field, state) => {
        if (state) {
            expectedCounters[field] = true
        } else {
            delete expectedCounters[field]
        }
    }

    const setSeason = (season) => {
        seStore.request.season = season
    }
    const getSeason = () => {
        return seStore.request.season
    }

    const getSeRequestBase = () => {
        // initial
        const request = {
            criteria: [],
            season: getSeason()
        }

        // engine
        const _engineId = engineId || instance.options.engineId
        if (_engineId) {
            request.engineId = _engineId
        } else {
            request.engine = engine
        }

        return request
    }

    const getSeRequest = (options = {}) => {
        const { counters = true } = options

        // initial
        const request = {
            ...seStore.request
        }

        // engine
        const _engineId = engineId || instance.options.engineId
        if (_engineId) {
            request.engineId = _engineId
        } else {
            request.engine = engine
        }

        // counters
        if (counters) {
            const fieldCounters = Object.keys(expectedCounters)
            request.expectedReturn = {
                fields: instance.options.fieldCounters.filter((field) => !seStore.exclude.fields.includes(field)),
                criteria: instance.options.criteriaCounters.filter((criteriaId) => !seStore.exclude.criterias.includes(criteriaId)),
                fieldCounters: fieldCounters.length > 0 ? fieldCounters : undefined
            }
        }

        // customize
        if (instance.options.modifySeRequest) {
            instance.options.modifySeRequest(request)
        }

        return request
    }
    const getSeRequestProductsByName = (liheName, options = {}) => {
        const { ignoreDates } = options
        const request = { ...getSeRequest() }
        delete request.expectedReturn
        delete request.country
        delete request.region
        delete request.domaineSki
        delete request.department
        delete request.station
        delete request.nearbyLat
        delete request.nearbyLon
        delete request.nearbyDist
        delete request.prestIds
        delete request.liheIds
        if (ignoreDates) {
            delete request.beginDate
            delete request.endDate
        }
        request.liheName = liheName
        return request
    }
    const getSeRequestProductsById = (ids) => {
        const request = { ...getSeRequest() }
        delete request.country
        delete request.region
        delete request.domaineSki
        delete request.department
        delete request.station
        delete request.nearbyLat
        delete request.nearbyLon
        delete request.nearbyDist
        delete request.prestIds
        request.liheIds = ids
        return request
    }
    const getSeRequestProductsByPrestId = (ids, options = {}) => {
        let request
        if (options.clearRequest) {
            request = getSeRequestBase()
        } else {
            request = { ...getSeRequest() }
            delete request.country
            delete request.region
            delete request.domaineSki
            delete request.department
            delete request.station
            delete request.nearbyLat
            delete request.nearbyLon
            delete request.nearbyDist
            delete request.liheIds
        }
        request.prestIds = ids
        return request
    }
    const getStartDatesRequest = () => {
        const request = { ...getSeRequest() }
        delete request.beginDate
        delete request.endDate
        return request
    }
    const getEndDatesRequest = (startDate) => {
        const request = { ...getSeRequest() }
        if (startDate) {
            request.beginDate = startDate
        }
        delete request.endDate
        return request
    }
    const getProductsQueryParams = () => {
        const params = {
            size: seStore.resultsPerPage,
            start: seStore.page
        }
        if (seStore.sort.type) {
            params.orderBy = seStore.sort.type
            params.sort = seStore.sort.direction
        }
        return params
    }
    const setCountersResponse = (result) => {
        seStore.lastResponseRaw = result
        setCountersWithExcluded(result)
        // COUNTERS event
        events.fire(eventNames.COUNTERS, result)
    }
    const setProductsResponse = (result) => {
        seStore.lastResponseRaw = result

        // COUNTERS event
        // setCountersWithExcluded(result.seParamsResponse);
        // events.fire(eventNames.COUNTERS, seStore.counters);

        // PRODUCTS event
        seStore.products = result.products
        // events.fire(eventNames.PRODUCTS, seStore.products);

        // RESULT_CONTROLS event
        seStore.page = (result.pageIndex - 1).toString()
        seStore.page = seStore.page < 0 ? '0' : seStore.page
        seStore.totalPages = result.pageCount
        seStore.totalProducts = result.totalProducts
        // events.fire(eventNames.RESULT_CONTROLS, {
        // 	page: seStore.page,
        // 	totalPages: seStore.totalPages,
        // 	totalProducts: seStore.totalProducts,
        // });

        // RESULTS_PER_PAGE event
        // seStore.resultsPerPage = (result.pageSize).toString();
        events.fire(eventNames.PRODUCTS)

        // events.fire(eventNames.RESULTS_PER_PAGE, seStore.resultsPerPage);
    }
    const setCountersWithExcluded = (counters) => {
        const { criterias, fields } = getExcluded()
        const keepFields = fields.reduce((data, field) => {
            if (seStore.counters[field]) {
                data[field] = seStore.counters[field]
            }
            return data
        }, {})
        const keepsCriterias = criterias.reduce((data, id) => {
            if (seStore.counters.criteria.includes(id)) {
                data.push(id)
            }
            return data
        }, [])
        seStore.counters = {
            ...counters,
            ...keepFields,
            criteria: [...counters.criteria, ...keepsCriterias]
        }
    }
    const getSeFilters = () => {
        return data.request
    }
    const setSeFilters = (data) => {
        // FILTERS event
        seStore.request = data.request
        // events.fire(eventNames.FILTERS);

        // RESULT_CONTROLS event
        seStore.page = data.page || '0'
        seStore.totalPages = data.totalPages || null
        seStore.totalProducts = data.totalProducts || null
        // events.fire(eventNames.RESULT_CONTROLS, {
        // 	page: seStore.page,
        // 	totalPages: seStore.totalPages,
        // 	totalProducts: seStore.totalProducts,
        // });

        // RESULTS_PER_PAGE event
        seStore.resultsPerPage = data.resultsPerPage || '10'
        // events.fire(eventNames.RESULTS_PER_PAGE, seStore.resultsPerPage);

        // SORT event
        seStore.sort = data.sort || {
            type: null,
            direction: null
        }
        // events.fire(eventNames.SORT, seStore.sort);
        events.fire(eventNames.REQUEST)
    }
    const setMapResponse = (result) => {
        // MAP event
        seStore.map = result
        events.fire(eventNames.MAP)
    }
    const getMapData = () => {
        return seStore.map
    }
    const setGeoResponse = (result) => {
        // GEO_DATA event
        geoStore.countries = result.countries
        geoStore.domaines = result.domaines
        geoStore.departments = result.departments
        geoStore.parentStations = result.parentStations
        geoStore.regions = result.regions
        geoStore.stations = result.stations
        events.fire(eventNames.GEO_DATA)
    }
    const getGeoData = () => {
        return geoStore
    }

    const getProducts = () => {
        return seStore.products
    }
    const getProductsNum = () => {
        return seStore.totalProducts
    }
    const getPagesNum = () => {
        return seStore.totalPages
    }

    // criterias: [id, id]
    // values: [{field, id}] // for array fields
    const getSelected = ({ values = [], criterias = [] }) => {
        const result = {
            values: [],
            criterias: []
        }
        if (criterias.length > 0) {
            result.criterias = getSelectedCriterias(criterias)
        }
        if (values.length > 0) {
            const selectedByField = {}
            result.values = values.filter(({ field, id }) => {
                selectedByField[field] = selectedByField[field] || getSelectedFieldValues(field)
                if (selectedByField[field].find((_id) => _id === id)) {
                    return true
                }
            })
        }
        return result
    }
    const isSelected = ({ values = [], criterias = [], availableOnly = false }) => {
        // console.log('isSelected: SE: ', values, criterias, availableOnly)
        if (availableOnly) {
            const available = getAvailable({ values, criterias })
            values = available.values
            criterias = available.criterias
        }
        const selected = getSelected({ values, criterias, availableOnly })
        const selectedNum = selected.values.length + selected.criterias.length
        const checkNum = values.length + criterias.length
        if (selectedNum > 0 && checkNum > selectedNum) {
            return 'partly'
        } else if (selectedNum > 0 && selectedNum === checkNum) {
            return true
        } else {
            return false
        }
    }
    const getAvailable = ({ values = [], criterias = [] }) => {
        const result = {
            values: [],
            criterias: []
        }
        if (criterias.length > 0) {
            result.criterias = getAvailableCriterias(criterias)
        }
        if (values.length > 0) {
            const availableByField = {}
            result.values = values.filter(({ field, id }) => {
                availableByField[field] = availableByField[field] || getAvailableFieldValues(field)
                if (availableByField[field].find((_id) => _id === id)) {
                    return true
                }
            })
        }
        result.isAvailable = _isAvailable({ values, criterias, available: result })
        return result
    }
    const isAvailable = ({ values = [], criterias = [] }) => {
        const available = getAvailable({ values, criterias })
        return _isAvailable({ values, criterias, available })
    }
    const _isAvailable = ({ values, criterias, available }) => {
        // console.log('values: ', values)
        if (
            (available.values.length > 0 && values.length > available.values.length) ||
            (available.criterias.length > 0 && criterias.length > available.criterias.length)
        ) {
            return 'partly'
        } else if (values.length === available.values.length && criterias.length === available.criterias.length) {
            return true
        } else {
            return false
        }
    }
    const getAvailableNotSelected = ({ values = [], criterias = [] }) => {
        const available = getAvailable({ values, criterias })
        const selected = getSelected({ values, criterias })

        const result = {
            values: available.values.filter(({ field, id }) => {
                return !selected.values.find((s) => s.field === field && s.id === id)
            }),
            criterias: available.criterias.filter((id) => {
                return !selected.criterias.find((_id) => _id === id)
            })
        }
        result.hasAvailableNotSelected = _hasAvailableNotSelected(result)

        return result
    }
    const hasAvailableNotSelected = ({ values = [], criterias = [] }) => {
        const available = getAvailableNotSelected({ values, criterias })
        return _hasAvailableNotSelected(available)
    }
    const _hasAvailableNotSelected = (available) => {
        return available.criterias > 0 || available.values > 0
    }
    const add = ({ values = [], criterias = [], all = false }) => {
        events.batch(() => {
            const available = all ? { values, criterias } : getAvailable({ values, criterias })
            values.forEach(({ field, id }) => {
                addFieldValue(field, id)
            })
            addCriterias(available.criterias)
        })
    }
    const remove = ({ values = [], criterias = [] }) => {
        events.batch(() => {
            values.forEach(({ field, id }) => {
                removeFieldValue(field, id)
            })
            removeCriterias(criterias)
        })
    }

    let engine = instance.options.engine
    const getEngine = () => engine
    const setEngine = (_engine) => {
        engine = _engine
        events.fire(eventNames.ENGINE)
    }

    let engineId
    const getEngineId = () => engineId || instance.options.engineId
    const setEngineId = (_engineId) => {
        engineId = _engineId
        events.fire(eventNames.ENGINE)
    }

    // geo
    // const mapParentStationToChildren = (stationId, parentStations) => {
    // 	const _parentStations = parentStations || geoStore.parentStations;
    // 	const {id: parentStationId} = _parentStations.find(({id}) => id === stationId);
    // 	if(parentStationId){
    // 		return geoStore.stations.filter(station => station.parentStationId === parentStationId)
    // 			.map(({id}) => id);
    // 	}else{
    // 		return [stationId];
    // 	}
    // }

    events.fire(eventNames.INIT)

    return {
        // specific events
        onSelectedCriterias,
        onAvailableCriterias,
        onFieldValue,
        onCounters,
        onSelectedFieldValues,
        onAvailableFieldValues,

        // filters - for components
        addCriterias,
        removeCriterias,
        setFieldValue,
        addFieldValue,
        removeFieldValue,
        clearRequest,
        clearFilters,

        // results controls - for components
        setSort,
        getSort,
        setResultsPerPage,
        getResultsPerPage,
        setPage,
        getPage,

        // criterias and field values - for components
        getAvailableCriterias,
        getSelectedCriterias,
        getAvailableFieldValues,
        getAvailableCapacityValuesSorted, // capacity specific getAvailableFieldValues
        getCounter,
        getValueCounter,
        getCriteriaCounter,
        getSelectedFieldValues,
        getFieldValue,

        // values & criterias
        getSelected,
        isSelected,
        getAvailable,
        isAvailable,
        getAvailableNotSelected,
        hasAvailableNotSelected,
        add,
        remove,

        // counters
        setCriteriaCounters,
        setFieldCounters,

        // exclude
        setExcluded,
        getExcluded,

        // counters
        setExpectedCounter,

        // season
        setSeason,
        getSeason,

        // se request - for server
        getSeRequestBase,
        getSeRequest,
        getSeRequestProductsByName,
        getSeRequestProductsById,
        getSeRequestProductsByPrestId,
        getStartDatesRequest,
        getEndDatesRequest,
        getProductsQueryParams,
        setCountersResponse,
        setProductsResponse,

        // results
        getProducts,
        getProductsNum,
        getPagesNum,

        // for url
        getSeFilters,
        setSeFilters,
        getEngine,
        setEngine,
        getEngineId,
        setEngineId,

        // map
        getMapData,
        setMapResponse,

        // geo request
        setGeoResponse,
        getGeoData

        // mapParentStationToChildren,
    }
}

const preInitStore = (instance) => {
    const events = initEvents(instance)
    return {
        eventNames,
        events,
        init: () => initStore({ instance, events })
    }
}

export default preInitStore
